import { client } from './client';

// --- Suppliers ---

export const suppliers = async () => {
    const response = await client.get('/v1/suppliers');
    return response.data?.items ?? response.data;
};

export const getSupplier = async (uid) => {
    const response = await client.get(`/v1/suppliers/${uid}`);
    return response.data;
};

export const createSupplier = async (data) => {
    const response = await client.post('/v1/suppliers', data);
    return response.data;
};

export const updateSupplier = async (uid, data) => {
    const response = await client.put(`/v1/suppliers/${uid}`, data);
    return response.data;
};

export const deleteSupplier = async (uid) => {
    const response = await client.delete(`/v1/suppliers/${uid}`);
    return response.data;
};
